module.exports = __webpack_public_path__ + "static/logo_black-e19a085c90f6faf01a98ac5a2e45b4f2.png";